import React, { Fragment, useCallback, useEffect, useState } from 'react';
import Request from '../../../core/requests';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useDispatch, useSelector } from 'react-redux';
import { Loading } from '../../../components/common';
import { openSnackbar } from "store/slices/snackbar";
import { ValidationSchemaChangePsw } from 'conf/users';
import ProfileChangePasswordForm from 'forms/profile/ProfileChangePassword.form';
import { logout, refreshToken } from "store/user.store";

const ProfileChangePasswordContainer = ({ title }) => {
    const dispatch = useDispatch();
    const { user, token, error: errorRefresh, loading: loadingRefresh } = useSelector((state) => state.user);

    const [isFirstRefresh, setIsFirstRefresh] = useState(true);
    const [dataSubmit, setDataSubmit] = useState(null);
    const [loading, setLoading] = useState(false);

    const { handleSubmit, control, formState } = useForm({
        resolver: yupResolver(ValidationSchemaChangePsw),
        defaultValues: {
            password: '',
            matchingPassword: '',
        },
    });

    const onSuccess = useCallback((resp) => {
        setIsFirstRefresh(true)

        dispatch(
            openSnackbar({
                open: true,
                message: resp.message,
                variant: "alert",
                alert: {
                    color: resp.status,
                },
                close: false,
            })
        );
        // eslint-disable-next-line
    }, []);

    const onLogout = useCallback((error) => {
        if (error?.response?.status === 403 || error?.response?.status === 401) {
            dispatch(logout())
        }
        // eslint-disable-next-line
    }, [])

    const onError = useCallback(
        (error, data) => {
            setLoading(false);
            setDataSubmit(data)
            if (isFirstRefresh) {
                setLoading(false);
                if (error?.response?.status === 403) {
                    dispatch(logout());
                } else {
                    if (error?.response?.status !== 401) {
                        onFailure(error);
                    } else {
                        if (isFirstRefresh) {
                            dispatch(
                                refreshToken({
                                    grant_type: "refresh_token",
                                    refresh_token: user.refresh_token,
                                })
                            );
                            setIsFirstRefresh(false);
                        }
                    }
                }
            } else {
                onLogout(error);
            }
        },
        // eslint-disable-next-line
        []
    );


    const onFailure = useCallback((error) => {
        dispatch(
            openSnackbar({
                open: true,
                message: error.response?.data?.message ? error.response.data.message : "Errore",

                variant: "alert",
                alert: {
                    color: "error",
                },
                close: false,
            })
        );
        // eslint-disable-next-line
    }, []);

    const onSubmit = useCallback((values) => {
        const data = { ...values, }
        if (user.userId)
            Request.users
                .changePasswordUser({ user_id: user.userId, token: token, }, data)
                .then((resp) => onSuccess(resp))
                .catch((error) => onError(error, data));

        // eslint-disable-next-line
    }, [token]);

    useEffect(() => {
        if (!isFirstRefresh && !errorRefresh && !loadingRefresh) {
            onSubmit(dataSubmit)
        }
        // eslint-disable-next-line
    }, [isFirstRefresh, loadingRefresh, errorRefresh, dataSubmit])


    return (
        <Fragment>
            {loading && <Loading />}

            <ProfileChangePasswordForm
                errors={formState.errors}
                control={control}
                handleSubmit={handleSubmit(onSubmit)}
                title={title}
            />
        </Fragment>
    );
};

export default ProfileChangePasswordContainer;
